import { config } from '@services/config';
import { CustomerDocumentSearchResponse } from '@lio/api-types';
import { customerQueryKey } from '@services/customer/keys';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useCustomerDocumentCount = (customerId?: string) => {
  const client = useClient();
  const result = useQuery<CustomerDocumentSearchResponse>({
    queryKey: customerQueryKey.getDocumentCount({ customerId }),
    queryFn: () =>
      client.get(`customer/${customerId}/document?pageLimit=1&sort=-createdAt`).json<CustomerDocumentSearchResponse>(),
    enabled: !!customerId,
    ...config,
  });
  return { ...result, documentCount: result.data?.pagination.total };
};
